import { UnitSystemOptionsType } from "../../components/Settings/Settings.types.tsx";
import { StandardFormData } from "./StandardProjectModal.types.tsx";

type TemperatureField = "leaving_water_temperature" | "entering_water_temperature";

const FIELDS: TemperatureField[] = ["leaving_water_temperature", "entering_water_temperature"];

// Condiciones de calificacion AHRI, en °F. Chillers: AHRI 550/590, agua a 44/54. Unidades
// condensadoras: AHRI 365, succion saturada a 45 (el campo de salida es la evaporacion).
// Las bombas de calor no tienen precarga.
const AHRI_FAHRENHEIT: Record<string, Partial<Record<TemperatureField, number>>> = {
  "1": { leaving_water_temperature: 44, entering_water_temperature: 54 },
  "2": { leaving_water_temperature: 44, entering_water_temperature: 54 },
  "5": { leaving_water_temperature: 45 },
  "6": { leaving_water_temperature: 45 },
};

const toUnitSystem = (fahrenheit: number, unitSystem: UnitSystemOptionsType): string =>
  unitSystem === "SI"
    ? (Math.round((((fahrenheit - 32) * 5) / 9) * 10) / 10).toString()
    : fahrenheit.toString();

const defaultFor = (
  systemId: string,
  field: TemperatureField,
  unitSystem: UnitSystemOptionsType
): string => {
  const fahrenheit = AHRI_FAHRENHEIT[String(systemId)]?.[field];
  return fahrenheit === undefined ? "" : toUnitSystem(fahrenheit, unitSystem);
};

/**
 * Temperaturas al cambiar de sistema. Solo se reemplaza lo que esta vacio o sigue siendo la
 * precarga del sistema anterior: lo que el usuario escribio a mano no se toca.
 */
export const ahriTemperatures = (
  prev: StandardFormData,
  nextSystemId: string,
  unitSystem: UnitSystemOptionsType
): Partial<Record<TemperatureField, string>> => {
  const result: Partial<Record<TemperatureField, string>> = {};

  for (const field of FIELDS) {
    const current = String(prev[field] ?? "");
    if (current === "" || current === defaultFor(prev.system_id, field, unitSystem)) {
      result[field] = defaultFor(nextSystemId, field, unitSystem);
    }
  }

  return result;
};
